import PickupOrderDetail from './PickupOrderDetail.vue'

export default PickupOrderDetail
